module.exports = __webpack_public_path__ + "static/img/spinningwheel.0560b6d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinningwheel.gif
// module id = zPyx
// module chunks = 1